export default "__VITE_ASSET__Mas0hnYF__"